import React from 'react';
import { string } from 'prop-types';

const RecordingsIcon = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <title>recording-icon</title>
      <g fill="none">
        <g>
          <g transform="translate(-70 -340) translate(70 340)">
            <circle cx="20" cy="20" r="20" fill="#F2F2F2" />
            <g fill="#428A13">
              <path
                d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m0 2c4.963 0 9 4.038 9 9s-4.037 9-9 9-9-4.038-9-9 4.037-9 9-9"
                transform="translate(8 8)"
              />
              <path d="M19 12c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7" opacity=".5" transform="translate(8 8)" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

RecordingsIcon.propTypes = {
  className: string
};

RecordingsIcon.defaultProps = {
  className: ''
};

export default RecordingsIcon;
